export default "__VITE_ASSET__e1489599__"